<template lang="pug">
#Cpet_sheet
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_Cpet_sheet.jpg" alt="banner C-pet sheet")
        img.img-fluid.small(src="img/banner/banner_Cpet_sheet_mobile.jpg" alt="banner C-pet sheet")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 C-PET SHEET 
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 C-PET sheet is heated and further processed by compression molding machine 
        <br/> so that the molded product can withstand high temperatures after crystallization.
  section#product_profile
    b-row.menu
      b-col.text-center.active C-PET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span Product application description
            p C- PET is highly crystalline, has thermoplasticity, is non-toxic, has high strength and high temperature resistance.
          div
            h3 
              span Product Features
            ol.d-flex.flex-wrap
              li.col-12.col-lg-6.pl-0(v-for="item in a_feature" :key="item.message") {{ item.message }}
          
          b-row(class="mx-0")
            b-col(cols="12" sm="6" class="pl-0")
                div
                    h3 
                        span Product Information
                    ol
                        li(v-for="item in a_use" :key="item.message") {{ item.message }}
            b-col.pl-0(cols="12" sm="6")
                div
                    h3 
                        span Product Certificate
                    p 
                      a(href="img/certification/PL_Certificate_CPET_Product_2024.pdf" target="_blank") PL Certificate
                      | 、 
                      a(href="img/certification/SGS_TestReport.pdf" target="_blank") SGS
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span C-PET Specification
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_1
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span(v-html="item.name")
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.pull")
              li 
                span(v-html="item.elongation")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 Others
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'C-PET SHEET - NAN YA RIGID FILM',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.' },
            { name: 'Keywords', content: 'Nan Ya Plastics, Rigid Film, APET, GREEN APET, PCR resins' },
            { name: 'og:title', content: 'C-PET SHEET  - NAN YA RIGID FILM' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com/' },
            { name: 'og:description', content: 'C-PET sheet is heated and further processed by compression molding machine so that the molded product can withstand high temperatures after crystallization.' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: 'C-PET SHEET',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/cpet_sheet_img01.jpg',
            img_alt: 'C-pet sheet img01' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/cpet_sheet_img02.jpg',
            img_alt: 'C-pet sheet img02' },
          { 
            id: '3',
            img_src: 'img/application_Desktop/cpet_sheet_img03.jpg',
            img_alt: 'C-pet sheet img03' },
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: 'Suggested temperature -20℃～200℃.' },
          { message: 'Excellent anti-water/oxygen.' },
          { message: 'Flavor keeping.' },
          { message: 'Obtain PL certificate.' }
        ],
        a_use: [
          { message: 'Containers for Microwave and Refrigerator.' },
          { message: 'Baking packing.' }
        ],
        a_specification: [
          { 
            id: '1',
            name: 'C-PET SHEET AFVM',
            feature: 'Feature：Obtain PL certificate、Good formability',
            outward: 'Appearance： colored',
            thickness: 'Thickness<sub>(mm)</sub>：0.2~1.4',
            proportion: 'S.G<sub>(g/cm3)</sub>：白色1.35±0.03',
            gloss: 'Gloss Value：<br/><span class="pl-5">90↑</span>',
            pull: 'Tensile strength<sub>(kg/cm2)</sub>:<br/><span class="pl-5">>600</span>',
            elongation: 'Elongation<sub>(%)</sub>：>300'}
        ],
        swiperOption_apet: {
          slidesPerView: 1,
          spaceBetween: 30,
          breakpoints: {
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'Food and Medical use',
            text:'A flat plastic sheet is formed into a three-dimensional curved package by blister equipment which use high temperature and molds, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'Antistatic Packaging',
            text:'Using blister equipment, using high temperature and molds, the flat plastic sheet is formed into a three-dimensional packaging curved shell, so that consumers can directly see the product and protect it.',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'Decoration Materials',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing. Composite plastic building materials decoration products are made by hot pressing of multi-layer structure, generally 3-5 layer structure laminated, including wear-resistant layer (including UV treatment layer), printed decoration layer, middle material layer, base material layer, etc..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'Card Lamination',
            text:'This product can be processed into various cards through printing, laminating, card punching, coding, and sub-card quality inspection.',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'For Stationery',
            text:'On a continuous substrate, products made through processes such as printing, coating, laminating or pressing for majority of Printing process.',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'6',
            name:'Cooling Tower',
            text:'Press working and forming process are good for the product.Forming process has to regulate quality.',
            url:'./img/application_Desktop/other_pic_6.jpg',
            href_link: 'water_treatment'
          },
          {
            id:'7',
            name:'Green Apet',
            text:'GREEN APET uses PCR resins made from recycled PET bottles as its raw material, reducing emissions of carbon and waste, providing consumers with an eco-friendly products.',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#Cpet_sheet
  #specification
    background-image: url(../assets/bg/bg_cpet_sheet.jpg)

</style>
